// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"MessageActions_feedbackContainer__xdAZr","copyButton":"MessageActions_copyButton__-bwKJ"};